const u = (t) => t ? Object.keys(t).length === 0 : !0, e = [
  "SAFETY_DATA_SHEET",
  "FOOD_CONTACT_CONFORMITY_CERTIFICATE",
  "IFU"
], o = (t, T) => {
  var c, n;
  return (n = (c = t == null ? void 0 : t[T]) == null ? void 0 : c.documents) == null ? void 0 : n.some(
    (r) => e.includes(r.mediaType)
  );
}, E = (t) => e.includes(t), i = (...t) => t.filter((T) => !!T).join(" ").trim() || void 0;
export {
  u as assetResponseIsEmpty,
  i as classes,
  o as hasDocuments,
  E as isSupportedDocumentType
};
